class If_Empty {
    static path = 'logic/if-empty';

    constructor(mutator){
        this.addInput("Data", "");
        this.addOutput("True/False", "boolean");
        this.bgcolor = '#9fe2fc';
        this.title = 'If Empty';
        this.desc = 'Detect if the data is empty';
    }
}

module.exports = If_Empty
